import React, { useState, useEffect,useMemo } from "react";
import { HotTable, HotColumn } from "@handsontable/react";

import {
  drawCheckboxInRowHeaders,
  addClassesToRows,
  alignHeaders,
} from "./handsontableHelpers";
import "handsontable/dist/handsontable.min.css";

interface DuesExcelViewProps {
  data: any[];
  membercount: number;
  addition: number;
  SelectValue: string;
  onRowSelect: (rowIndex: number, rowData: any[]) => void;
  onExcelrowClick: (excelrowdata: string) => void;
}

const DuesExcelView: React.FC<DuesExcelViewProps> = ({
  addition,
  membercount,
  data,
  SelectValue,
  onRowSelect,
  onExcelrowClick,
}) => {
  const [width, setWidth] = useState(window.innerWidth);
  const [dataState, setDataState] = useState(data);
  const [copiedOnce, setCopiedOnce] = useState(false);
  const [copyfirst, setcopyfirst] = useState(false);
  const [copyheaders, setcopyheaders] = useState<any[]>([]);
  const [copybody, setcopybody] = useState<any[]>([]);
  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
      console.log("가로사이즈 : " + window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const columnHeaders = useMemo(() => {
    if (data.length > 0) {
      // console.log("(ExcelView) 헤더 : " +  data[1])
      return data[1];
    }
    return [];
  }, [data]);

  const handleRowSelect = (rowIndex: number, rowData: any[]) => {
    const excelrowdata = JSON.stringify(rowData);
  
    if (excelrowdata) {
      onExcelrowClick(excelrowdata);
    }
  };
  // if(addition===0){
  //   window.alert("회원 추가하기버튼을 클릭해서 추가해주세요"); // 성공 메시지
  // }
  // console.log("(ExcelView) 추가회원 수 : " + addition);
  return (
    <div style={{width:"100%",height:"100%"}}>
      <HotTable
        data={copiedOnce ? data.slice(2) : data.slice(1)}
        height="100%"
        width="100%"
        
        colHeaders={membercount >= 2 ? data[0] : copiedOnce ? copyheaders : data[0]}
        readOnly={true}
        colWidths={200}
        hiddenColumns={{
          indicators: true,
        }}
        afterChange={(changes, source) => {
          if (source === "CopyPaste.paste" && changes) {
            // console.log("(ExcelView) 복붙상황")
            // console.log("(ExcelView) 헤더 : " +  data[1])
            if(membercount>=2){
            }else{
              if(copyfirst==false){
                setcopyheaders(data[1]);
                setcopybody(data.slice(1))
                setCopiedOnce(true);
                setcopyfirst(true)
              }
            }
          }else{
            // console.log("(ExcelView) 일반상황")
            // console.log("(ExcelView) 복사한 헤더 : " +copyheaders);
          }
        }}
        contextMenu={true}
        multiColumnSorting={true}
        rowHeaders={true}
        
        afterGetColHeader={alignHeaders}
        beforeRenderer={(TD, row, column, prop, value, cellProperties) => {
          if(row>=addition&& addition >= 1){
            TD.style.color = 'blue';
          }
          
          
        }}
        manualRowMove={true}
        licenseKey="non-commercial-and-evaluation"
        
        afterSelection={(
          r,
          c,
          r2,
          c2,
          preventScrolling,
          selectionLayerLevel,
        ) => {
          const selectedRowData = dataState[r+1];
          onRowSelect(r, selectedRowData);
          handleRowSelect(r, selectedRowData);
        }}
      >
      {Array.from({ length: 4}, (_, index) => (
        <HotColumn key={index} data={index} />
      ))}
      </HotTable>
    </div>
  );
};

export default DuesExcelView;
